module.exports = __webpack_public_path__ + "assets/tutorials/Testing_Content_with_EmotionTrac.png";